import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fileInput", "status", "submit"]
  static values = {
    loadingText: String
  }

  connect() {
    this.dragDepth = 0
  }

  submit() {
    this.element.setAttribute("aria-busy", "true")
    this.element.classList.add("is-uploading")

    if (this.hasStatusTarget) {
      this.statusTarget.classList.remove("d-none")
    }

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true

      if (this.hasLoadingTextValue) {
        this.submitTarget.value = this.loadingTextValue
      }
    }
  }

  dragenter(event) {
    this.preventFileDropDefault(event)
    this.dragDepth += 1
    this.element.classList.add("is-dragging")
  }

  dragover(event) {
    this.preventFileDropDefault(event)

    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = "copy"
    }

    this.element.classList.add("is-dragging")
  }

  dragleave(event) {
    this.preventFileDropDefault(event)
    this.dragDepth = Math.max(this.dragDepth - 1, 0)

    if (this.dragDepth === 0) {
      this.element.classList.remove("is-dragging")
    }
  }

  drop(event) {
    this.preventFileDropDefault(event)
    this.dragDepth = 0
    this.element.classList.remove("is-dragging")

    const file = this.firstImageFile(event.dataTransfer && event.dataTransfer.files)

    if (!file || !this.hasFileInputTarget) {
      return
    }

    this.assignDroppedFile(file, event.dataTransfer.files)
    this.fileInputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.submitForm()
  }

  preventFileDropDefault(event) {
    event.preventDefault()
    event.stopPropagation()
  }

  firstImageFile(files) {
    return Array.from(files || []).find((file) => file.type.startsWith("image/"))
  }

  assignDroppedFile(file, files) {
    const selectedFiles = this.fileListFor(file, files)

    try {
      this.fileInputTarget.files = selectedFiles
    } catch (_error) {
      Object.defineProperty(this.fileInputTarget, "files", {
        value: selectedFiles,
        configurable: true
      })
    }
  }

  fileListFor(file, files) {
    if (files.length === 1 && files[0] === file) {
      return files
    }

    if (typeof DataTransfer === "undefined") {
      return [file]
    }

    const transfer = new DataTransfer()
    transfer.items.add(file)
    return transfer.files
  }

  submitForm() {
    if (typeof this.element.requestSubmit === "function") {
      this.element.requestSubmit()
    } else {
      this.element.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }))
    }
  }
}
